/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidTraceability200,
  GetApiV1IndividualpaymentParcelsParcelidTraceability401,
  GetApiV1IndividualpaymentParcelsParcelidTraceability500,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidTraceability.ts";
import { individualPaymentTraceabilityViewModelSchema } from "../individualPaymentTraceabilityViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidTraceabilityPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams>;

export const getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParamsSchema =
  z.object({
    isBilletHistory: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidTraceability200Schema =
  z.array(
    z.lazy(() => individualPaymentTraceabilityViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceability200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidTraceability401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceability401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidTraceability500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceability500>;

export const getApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelidTraceability200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse>;
